import classNames from "classnames";
import { LocalDateTime } from "@js-joda/core";
import * as React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CHECK_SVG } from "../utils/svgs";
import { PLAY_ICON, SQUARE_ICON } from "../utils/svgs_new";
import ClockHour from "./ClockHour";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import Flex from "./Generic/Flex";
import { If } from "./Generic/If";
import { isDefined, IsDefined } from "./Generic/IsDefined";

interface Props {
  canClockIn: boolean;
  canClockOut: boolean;
  canSubmitTimesheet: boolean;
  clockInDateTime: LocalDateTime | null;
  clockOutDateTime: LocalDateTime | null;
  onClockIn: () => void;
  onClockOut: () => void;
  onSubmitTimesheet: () => void;
}

const ClockInOutFooter = (props: Props) => {
  const checkIcon = <AppIcon icon={CHECK_SVG} size={10} />;

  return (
    <div className="ClockInOutFooter">
      <Flex xGap={8} alignItems="center" stretchItems={true}>
        {props.canSubmitTimesheet ? (
          <AppButton variant="filled" onClick={props.onSubmitTimesheet}>
            {translate(STRINGS.SUBMIT_DUTIES)}
          </AppButton>
        ) : (
          <>
            <Flex stretchItems={true} className="ClockInButton">
              <If condition={!isDefined(props.clockInDateTime)}>
                <ClockButton type="IN" isActive={props.canClockIn} onClick={props.onClockIn} />
              </If>
              <IsDefined value={props.clockInDateTime}>
                {(x) => (
                  <AppButton variant="soft">
                    {checkIcon}
                    <ClockHour dateTime={x} />
                  </AppButton>
                )}
              </IsDefined>
            </Flex>
            <Flex stretchItems={true}>
              <If condition={!isDefined(props.clockOutDateTime)}>
                <ClockButton type="OUT" isActive={props.canClockOut} onClick={props.onClockOut} />
              </If>
              <IsDefined value={props.clockOutDateTime}>
                {(x) => (
                  <AppButton variant="soft">
                    {checkIcon}
                    <ClockHour dateTime={x} />
                  </AppButton>
                )}
              </IsDefined>
            </Flex>
          </>
        )}
      </Flex>
    </div>
  );
};

const ClockButton = (props: { isActive: boolean; type: "IN" | "OUT"; onClick: () => void }) => {
  const { icon, label } = {
    IN: { icon: PLAY_ICON, label: translate(STRINGS.CLOCK_IN) },
    OUT: { icon: SQUARE_ICON, label: translate(STRINGS.CLOCK_OUT) },
  }[props.type];

  return (
    <AppButton
      variant={props.isActive ? "filled" : "outline"}
      className={classNames({ disabled: !props.isActive })}
      onClick={props.onClick}
    >
      <AppIcon icon={icon} size={12} />
      <span>{label}</span>
    </AppButton>
  );
};

export default ClockInOutFooter;
